import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Components */
import HbHorizontalScrollView from '../../../../../components/Scroll/horizontal/HbHorizontalScrollView'
import HbPlaceholderFrame from '../../../../../components/Placeholder/frame/HbPlaceholderFrame'
import HbImageView from '../../../../../components/HbImage/view/HbImageView'

/* Constants */
import {
  PRODUCT_DETAIL_EXTENDED_CAROUSEL_THUMBNAIL_SIZES,
  PRODUCT_DETAIL_VIEW_TYPES_NAME
} from '../../../../../modules/product/productDesktopConstants'

/* Utils */
import {nativeSetScrollLeft} from '../../../../../common/dom/domUtils'

/* Styles */
import s from './product-detail-carousel-thumbnails.scss'

const ProductDetailCarouselThumbnails = memo((props) => {
  const {
    className,
    prefix,
    viewType,
    images,
    activeSlideIndex,
    onThumbnailClick,
    name
  } = props

  const imageSize = PRODUCT_DETAIL_EXTENDED_CAROUSEL_THUMBNAIL_SIZES[viewType];
  const imageSizeText = `${imageSize?.width}-${imageSize?.height}`;
  const imageRatio = imageSize?.width / imageSize?.height;

  return (
    <div className={cx(s.root, className)}>
      <HbHorizontalScrollView
        rootElementType={'ul'}
        initialFocusedItemCenter
        initialFocusedItemIndex={activeSlideIndex}
        nativeScroll={nativeSetScrollLeft}
        scrollDuration={500}>
        {
          images?.map((data, index) => {
            let isVideo = images?.[index].isVideo;
            let imagesUrl = isVideo
              ? images?.[0]?.url?.replace('{size}', imageSizeText)
              : images?.[index]?.url?.replace('{size}', imageSizeText);

            return (
              <li
                id={`${prefix}-carousel_dots${index}`}
                key={index}
                onClick={() => {
                  onThumbnailClick(index)
                }}>
                <a
                  id={`${prefix}-carousel__dot_item${index}`}
                  className={cx(s.navigation, s[PRODUCT_DETAIL_VIEW_TYPES_NAME[viewType]], {[s.active]: activeSlideIndex === index})}>
                  <HbPlaceholderFrame
                    ratio={imageRatio}>
                    <HbImageView
                      shouldLoadEagerly={index === 0}
                      forcePreload={index === 0}
                      image={{
                        src: imagesUrl,
                        size: imageSizeText,
                        componentSize: imageSize,
                        originSize: imageSize,
                        alt:`${name} ${index + 1}`,
                      }}/>
                  </HbPlaceholderFrame>
                </a>
              </li>
            )
          })
        }
      </HbHorizontalScrollView>
    </div>
  )
});

ProductDetailCarouselThumbnails.propTypes = {
  className: PropTypes.string,
  prefix: PropTypes.string,
  viewType: PropTypes.string,
  images: PropTypes.array.isRequired,
  activeSlideIndex: PropTypes.number.isRequired,
  onThumbnailClick: PropTypes.func
}

export default ProductDetailCarouselThumbnails
